import request from "@/request";

export const getType=()=>request.get(`/api/admin/categories/?pagesize=1000`)

export const createType=(data)=>request.post(`/api/admin/categories/`,data)

export const editType=(data)=>request.patch(`/api/admin/categories/${data.id}/`,data)

export const delType=(id)=>request.delete(`/api/admin/categories/${id}/`)